import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import axios from 'config/axios';
import { useSnackbar } from 'notistack';
import {
  UpdatePurposeIntentPayload,
  UpdatePurposeIntentResponse,
} from '../purposeIntent.types';

async function updatePurposeIntent(payload: UpdatePurposeIntentPayload) {
  let resource = '';

  switch (payload.action) {
    case 'add':
      resource = 'AddPurposeIntent';
      break;
    case 'remove':
      resource = 'RemovePurposeIntent';
      break;
    default:
      throw new Error(
        `${payload.action} has no corresponding resource defined`
      );
  }

  const response = await axios.post<UpdatePurposeIntentResponse>(resource, {
    purposeId: payload.purposeId,
    tagId: payload.tagId,
  });

  return response.data;
}

const useUpdatePurposeIntent = () => {
  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();

  const mutation = useMutation<
    UpdatePurposeIntentResponse,
    AxiosError,
    UpdatePurposeIntentPayload,
    unknown
  >(updatePurposeIntent, {
    onError: (err) => {
      console.error(err);
      enqueueSnackbar('Unable to update purpose intents.', {
        variant: 'error',
      });
    },
    onSuccess: (res) => {
      const variant = res.success ? 'success' : 'error';
      const toastMessage = res.success
        ? 'Successfully updated purpose intents.'
        : res.errorMessage;

      enqueueSnackbar(toastMessage, {
        variant,
      });
      queryClient.invalidateQueries(['purposeIntentForPurpose']);
    },
  });

  return mutation;
};

export default useUpdatePurposeIntent;
